'use strict';

import ngResource from 'angular-resource';

class ServiceStockService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/service_stock', {},
      {index: {method: 'GET', isArray: false}}
    );

    this.oem_api = $resource(
      '/api/oem/service_stock', {},
      {count: {method: 'GET', isArray: false, params: {count: true}}}
    );

    this.manage_api = $resource(
      '/:mode/api/service_stock',
      { mode: '@mode' },
      {
        index: {method: 'GET', isArray: true}
      }
    );
  }
}

export default angular.module('leptonApp.ServiceStockService', ['ngResource'])
  .service('ServiceStockService', ['$resource', ServiceStockService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/service_stock/service_stock.service.js